function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Stores promises for quick reuse of resolved values
 * TODO: Add TTI cache invalidation?
 * @private
 */
var PromiseCache = /*#__PURE__*/function () {
  function PromiseCache() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        shouldKeepResult = _ref.shouldKeepResult,
        shouldKeepError = _ref.shouldKeepError;

    _classCallCheck(this, PromiseCache);

    this._shouldKeepResult = shouldKeepResult;
    this._shouldKeepError = shouldKeepError;
    this._cache = {};
  }

  _createClass(PromiseCache, [{
    key: "cache",
    value: function cache(key, promiseCb) {
      var _this = this;

      var inflightValue = this._cache[key];
      if (inflightValue) return inflightValue;
      this._cache[key] = promiseCb().then(function (resolvedValue) {
        if (!_this._shouldKeepResult) {
          _this._cache[key] = null;
        }

        return resolvedValue;
      }).catch(function (e) {
        if (!_this._shouldKeepError) {
          _this._cache[key] = null;
        }

        throw e;
      });
      return this._cache[key];
    }
  }, {
    key: "isInCache",
    value: function isInCache(key) {
      return !!this._cache[key];
    }
    /**
     * Clear out the stored promises
     */

  }, {
    key: "clear",
    value: function clear() {
      this._cache = {};
    }
  }]);

  return PromiseCache;
}();

export { PromiseCache as default };